// plan-03 S05: command parser — bible §19

export interface ParsedCommand {
  cmd: string
  args: string[]
}

export function parseCommand(input: string): ParsedCommand | null {
  const trimmed = input.trim().toLowerCase()
  if (!trimmed) return null
  const parts = trimmed.split(/\s+/)
  return { cmd: parts[0], args: parts.slice(1) }
}
